import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '../lib/api';

import logger from '../lib/logger';
const RegionContext = createContext({ region: null, code: 'global', setRegionCode: () => {} });

export const REGION_OPTIONS = [
  { code: 'global', name: 'Global', flag: 'un' },
  { code: 'us', name: 'United States', flag: 'us' },
  { code: 'ca', name: 'Canada', flag: 'ca' },
  { code: 'in', name: 'India', flag: 'in' },
  { code: 'ae', name: 'United Arab Emirates', flag: 'ae' },
  { code: 'gb', name: 'United Kingdom', flag: 'gb' },
  { code: 'de', name: 'Germany', flag: 'de' },
  { code: 'au', name: 'Australia', flag: 'au' },
  { code: 'sg', name: 'Singapore', flag: 'sg' }
];

const FALLBACK = {
  global: { code: 'global', name: 'Global HQ', phone: '+1 786-673-2523', email: 'info@landdrafters.com', address: 'Apex, NC, USA · Pune, India', currency: 'USD', timezone: 'UTC', languages: ['en'] }
};

export const RegionProvider = ({ children }) => {
  const [code, setCode] = useState(() => {
    try { return localStorage.getItem('ld_region') || 'global'; } catch (e) {
      logger.warn('[region] localStorage read failed:', e);
      return 'global';
    }
  });
  const [region, setRegion] = useState(FALLBACK.global);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async (c) => {
    setLoading(true);
    try {
      const data = await api.region(c);
      setRegion(data);
    } catch (e) {
      // network error — keep fallback
      logger.warn(`[region] failed to load region ${c}:`, e);
      setRegion(FALLBACK.global);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    try { localStorage.setItem('ld_region', code); } catch (e) {
      logger.warn('[region] localStorage write failed:', e);
    }
    load(code);
  }, [code, load]);

  const setRegionCode = (c) => setCode(c);

  return (
    <RegionContext.Provider value={{ code, region, setRegionCode, loading }}>
      {children}
    </RegionContext.Provider>
  );
};

export const useRegion = () => useContext(RegionContext);
